import { styled } from '@mui/material/styles';
import { Box, Paper, Alert, Typography, Button } from '@mui/material';

export const LoginContainer = styled(Box)(() => ({
  height: '100vh',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const LoginHeader = styled(Typography)(() => ({
  fontWeight: 'bold',
  color: 'black',
  fontSize: '2rem',
}));

export const BackgroundContainer = styled(Box)({
  minHeight: '100vh',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundImage: 'url("/login-background.jpg")',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
});

export const LoginPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  width: '100%',
  maxWidth: '400px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: 'rgba(255, 255, 255, 0.95)',
}));

export const StyledAlert = styled(Alert)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const FormContainer = styled('form')(({ theme }) => ({
  width: '100%',
  marginTop: theme.spacing(1)
}));

export const StyledLink = styled('span')(({ theme }) => ({
  '& a': {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}));

export const LoginButton = styled(Button)({
  marginTop: "24px",
  marginBottom: "16px",
  width: "100%",
});